import { render, staticRenderFns } from "./TabTranscripcion.vue?vue&type=template&id=03036762&"
import script from "./TabTranscripcion.vue?vue&type=script&lang=js&"
export * from "./TabTranscripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports